import * as angular from "angular";
import {BringozApi} from "../../persistence-layer/models/bringoz-api.model";

function PricePlanAPI(): BringozApi {
  return {
    base: `/priceplans`,
    idKey: 'pricePlanId',
    infiniteScroll: {
      address: `/priceplans`,
      cmd: 'GET'
    },
    actions: {
      getTemplatesByType: {
        address: 'template',
        cmd: 'GET',
        updateable: false
      },
      updateProgramTemplate: {
        address: '{programId}/parent/{parentId}',
        cmd: 'POST',
        updateable: false
      },
      createTemplate: {
        address: 'template',
        cmd: 'PUT',
        updateable: false
      },
      getProgramData: {
        address: '{pricePlanId}',
        cmd: 'POST',
        updateable: true
      },
      getPricePlanPreferences: {
        address: '{pricePlanId}',
        cmd: 'POST',
        updateable: true
      },
      savePricePlanPreferences: {
        address: '{pricePlanId}/update',
        cmd: 'POST',
        updateable: true
      },
      deleteRelationPricePlanPreferences: {
        address: '{pricePlanId}/deleteRelation',
        cmd: 'DELETE',
        updateable: true
      },
      getServiceTimeAndSpecialDaysData: {
        address: '{pricePlanId}/serviceTimeData',
        cmd: 'GET'
      },
      getSpecialDays: {
        address: '{pricePlanId}/specialDay',
        cmd: 'GET'
      },
      updateCreateServiceTime: {
        address: '{pricePlanId}/serviceTime',
        cmd: 'POST'
      },
      updateCreateSpecialDay: {
        address: '{pricePlanId}/specialDay',
        cmd: 'POST'
      }
    }
  }
}

angular
  .module('bringoz.admin.pricePlan')
  .factory('PricePlanAPI', PricePlanAPI);
